import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Card from "../../components/Card";
import Markdown from "react-markdown";
import introductionPage from "./guide/introduction.md";
import platformOverviewPage from "./guide/platform-overview.md";
import setupPage from "./guide/setup.md";
import sizingChartPage from "./guide/sizing-chart.md";
import teamPage from "./guide/team.md";
import { capitalize } from "../../helpers/functions";

const pages = [
  { title: "introduction", content: introductionPage },
  { title: "platform overview", content: platformOverviewPage },
  { title: "setup", content: setupPage },
  { title: "sizing chart", content: sizingChartPage },
  { title: "team", content: teamPage },
];

export default function SendFeedbackPage() {
  const location = useLocation();
  const [content, setContent] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const idx = location.state?.guidePageIndex;
    if (typeof idx === "number" && pages[idx]) {
      setCurrentPage(idx);
    }
  }, [location.state]);

  useEffect(() => {
    getMarkdown(currentPage ? pages[currentPage].content : pages[0].content);
  }, [currentPage]);

  const getMarkdown = (file) => {
    fetch(file)
      .then((res) => res.text())
      .then((text) => {
        if (text) {
          setContent(text);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="container">
      <div className="flex items-center justify-between mb-10">
        <h1 className="page-title mb-0">Vendor Guide</h1>
      </div>
      <div className="flex gap-4">
        {pages?.length > 0 && (
          <Card className="mb-auto w-full max-w-[200px]">
            {pages.map((page, index) => {
              return (
                <p
                  key={index}
                  className={`font-medium cursor-pointer hover:text-primary-light underline-offset-4 my-1.5 ${
                    index === currentPage ? "text-primary underline" : ""
                  }`}
                  onClick={() => setCurrentPage(index)}
                >
                  {capitalize(page.title)}
                </p>
              );
            })}
          </Card>
        )}
        <Card className="vendor-guide-markdown flex-grow">
          <Markdown>{content}</Markdown>
        </Card>
      </div>
    </div>
  );
}
